import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import Db from '@/stores/db.js'
import { useUserStore } from '@/stores/userStore.js'

export const useAuthStore = defineStore('authStore', () => {
  const userStore = useUserStore()

  const DEVICE_IDENTIFIER_UNSPECIFIED = '__DEVICE_IDENTIFIER_UNSPECIFIED__'
  const deviceIdentifier = ref(undefined)

  async function setDeviceIdentifier(identifier) {
    if (!userStore.user) return null;
    await Db.set(Db.StoreType.DEVICE_IDENTIFIERS, { userId: userStore.user.fieldAgentId, partnerId: userStore.partner.id, identifier: identifier })
    deviceIdentifier.value = identifier
  }

  async function loadDeviceIdentifier() {
    if (userStore.user && userStore.partner) {
      const indexedDeviceIdentifier = await Db.fromKey(Db.StoreType.DEVICE_IDENTIFIERS, [userStore.user.fieldAgentId, userStore.partner.id])
      deviceIdentifier.value = indexedDeviceIdentifier ? indexedDeviceIdentifier.identifier : null
    }
    // Use DEVICE_IDENTIFIER_UNSPECIFIED when there is no user
    // E.g When not logged in Identifier === DEVICE_IDENTIFIER_UNSPECIFIED, when logged in Identifier === null
    // This allows us to watch for when a user logs in, but doesn't yet have a Device Identifier
    else deviceIdentifier.value = DEVICE_IDENTIFIER_UNSPECIFIED
  }

  function hasDeviceIdentifier() {
    return !(deviceIdentifier.value == null || deviceIdentifier.value === DEVICE_IDENTIFIER_UNSPECIFIED)
  }

    watch([() => userStore.user, () => userStore.partner], loadDeviceIdentifier, { immediate: true })

  function $reset() {
    deviceIdentifier.value = undefined
  }
  
  return { deviceIdentifier, setDeviceIdentifier, loadDeviceIdentifier, hasDeviceIdentifier, $reset }
},
  {
  persist: true
});